import ROUTES from 'routes';

export const clientPermission = {
  redirectUrl: ROUTES.MY_COMPANY(),
};
